// extracted by mini-css-extract-plugin
export var container = "transition-gallery-module--container--4c3a7";
export var errorText = "transition-gallery-module--error-text--a5536";
export var grid = "transition-gallery-module--grid--2749a";
export var loader = "transition-gallery-module--loader--ae9eb";
export var loading = "transition-gallery-module--loading--0d925";
export var noItems = "transition-gallery-module--no-items--a7897";